import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { fetchHistoricalEnrollmentsInfo } from '@actions/historicalMemberApplication/historicalApplicationsActionCreator';
import { useAppDispatch, useAppSelector } from '@hooks/index';
import { getHistoricalYears } from '../utils';
import { DEFAULT_COVERAGE_YEAR } from '../constants';
import YearSelector from '../../common/yearSelector';
import { HistoricalEnrollmentsContent } from '../components';

// ============================================================================
// Component
// ============================================================================

function HistoricalEnrollmentPage() {
    const dispatch = useAppDispatch();
    const { historicalEnrollmentsInfo } = useAppSelector(state => state.historicalApplications);
    const [searchParams] = useSearchParams();
    const referenceId = searchParams.get('referenceId') || '';
    const coverageYear = searchParams.get('coverageYear') || '';

    const [currentYear, setCurrentYear] = useState<string>(coverageYear || DEFAULT_COVERAGE_YEAR);

    useEffect(() => {
        if (!referenceId || !currentYear) {
            return;
        }
        dispatch(fetchHistoricalEnrollmentsInfo(currentYear, referenceId));
    }, [dispatch, currentYear, referenceId]);

    // On year dropdown change - just update state, useEffect handles the fetch
    const handleYearChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setCurrentYear(event.target.value);
    };

    // Get enrollments from Redux store
    const enrollments = historicalEnrollmentsInfo?.enrollments || [];

    return (
        <div className="padding-3" data-testid="historical-enrollment-container">
            {/* Header with Year Selector */}
            <div className="display-flex flex-justify flex-align-center margin-bottom-3">
                <h2 className="margin-0 font-weight-500"><FormattedMessage id="historical.member.applications.enrollments" values={{ currentYear }} /></h2>
                <YearSelector
                    years={getHistoricalYears()}
                    currentYear={currentYear}
                    onYearChange={handleYearChange}
                    titleId="indportal.enrollments.enrollmentYear"
                />
            </div>

            <HistoricalEnrollmentsContent enrollments={enrollments} />
        </div>
    );
}

export default HistoricalEnrollmentPage;
